module.exports = __webpack_public_path__ + "static/media/iconReporteActual.62b6fbbd.png";